module.exports = __webpack_public_path__ + "141d4a85/img/comments-icon.fdec7fdb.svg";